export default {
    translation: {
        common: {
            confirm: 'Confirm',
            cancel: 'Cancel',
            save: 'Save',
            saving: 'Saving...',
            loading: 'Loading...',
            error: 'Error',
            success: 'Success',
            confirmLogout: 'Are you sure you want to log out?',
            close: 'Close',
            previous: 'Previous',
            next: 'Next',
            retry: 'Retry',
            back: 'Back',
            submit: 'Submit',
            update: 'Update',
            submitting: 'Submitting...',
            optional: 'Optional',
            loginRequired: 'Please login first',
            edit: 'Edit',
            delete: 'Delete',
            deleting: 'Deleting...',
            exporting: 'Exporting...',
            select: 'Please select',
        },
        auth: {
            login: 'Login',
            register: 'Register',
            logout: 'Logout',
            email: 'Email',
            password: 'Password',
            username: 'Username',
            loginPage: {
                title: 'Sign In',
                subtitle: 'Access your account',
                emailLabel: 'Email',
                emailPlaceholder: 'your@email.com',
                passwordLabel: 'Password',
                passwordPlaceholder: '••••••••',
                signInButton: 'Sign in',
                signingIn: 'Signing in...',
                googleSignIn: 'Sign in with Google',
                noAccount: "Don't have an account?",
                register: 'Register now',
                forgotPassword: 'Forgot password?',
                resetPassword: {
                    title: 'Reset Password',
                    description: 'Enter your email address and we will send you a link to reset your password.',
                    emailSent: 'Password reset email has been sent. Please check your inbox.',
                    submit: 'Send Reset Link',
                    back: 'Back to Login',
                    errors: {
                        userNotFound: 'Email not found',
                        invalidEmail: 'Invalid email format',
                        default: 'Failed to send reset email, please try again later'
                    }
                },
                errors: {
                    invalidEmail: 'Invalid email format',
                    userNotFound: 'User not found',
                    wrongPassword: 'Incorrect password',
                    default: 'Login failed, please try again later',
                    googleSignIn: 'Google sign-in failed, please try again later'
                }
            },
            registerPage: {
                title: 'Create Account',
                subtitle: 'Join our community',
                usernameLabel: 'Username',
                usernamePlaceholder: 'Enter your username',
                emailLabel: 'Email',
                emailPlaceholder: 'your@email.com',
                passwordLabel: 'Password',
                passwordPlaceholder: '••••••••',
                registerButton: 'Register',
                registering: 'Registering...',
                hasAccount: 'Already have an account?',
                login: 'Sign in',
                success: {
                    message: 'Registration successful! We have sent a verification email to your inbox. Please check and verify before logging in.'
                },
                errors: {
                    emailInUse: 'This email is already registered',
                    invalidEmail: 'Invalid email format',
                    weakPassword: 'Password is too weak',
                    default: 'Registration failed, please try again later'
                }
            }
        },
        profile: {
            editUsername: {
                title: 'Edit Username',
                placeholder: 'Enter new username',
                empty: 'Username cannot be empty',
                lengthError: 'Username must be between 2-20 characters',
                updateFailed: 'Update failed, please try again'
            },
            title: 'My Profile',
            subtitle: 'Personal Information',
            loading: 'Loading',
            userNotFound: 'User not found, please contact admin',
            backToLogin: 'Back to Login',
            schedule: {
                title: 'My Schedule',
                subtitle: 'Class Timetable',
                adminNoSchedule: 'No schedule for admin',
                adminNoScheduleHint: 'Administrators do not have a class schedule'
            },
            information: 'Profile Information',
            email: {
                label: 'Email',
                verified: 'Verified',
                unverified: 'Unverified - Click to verify'
            },
            role: {
                label: 'Role',
                student: 'Student',
                teacher: 'Teacher',
                admin: 'Administrator'
            },
            status: {
                label: 'Status',
                active: 'Active',
                inactive: 'Disabled'
            },
            verifyEmail: {
                dialogTitle: 'Send Verification Email',
                dialogMessage: 'We will send a verification email to your inbox. Would you like to continue?',
                send: 'Send',
                cancel: 'Cancel',
                successTitle: 'Sent Successfully',
                successMessage: 'Verification email has been sent. Please check your inbox and click the verification link.',
                errorTitle: 'Send Failed',
                errorMessage: 'Failed to send verification email. Please try again later.',
                confirm: 'Got it',
                ok: 'OK'
            },
            changePassword: {
                title: 'Change Password',
                oldPassword: 'Current Password',
                newPassword: 'New Password',
                confirmPassword: 'Confirm New Password',
                submit: 'Change Password',
                cancel: 'Cancel',
                success: 'Password changed successfully',
                errors: {
                    wrongPassword: 'Current password is incorrect',
                    passwordMismatch: 'New passwords do not match',
                    weakPassword: 'New password is too weak',
                    default: 'Failed to change password, please try again later'
                }
            },
            myRegistrations: 'My Registrations',
            noRegistrations: 'You have not registered for any courses yet',
            registrationsFetchError: 'Failed to fetch registrations, please try again later',
            registrationId: 'Registration ID',
            registrationDate: 'Registration Date',
            totalPrice: 'Total Price (includes management fee)',
            earlyBirdPrice: 'Early Bird Price (before discount deadline)',
            amountPaid: 'Amount Paid',
            moreCourses: 'More Courses',
            selectedDates: 'Selected Dates',
            registrationStatus: {
                label: 'Registration Status',
                pending: 'Pending',
                approved: 'Approved',
                rejected: 'Rejected',
                waitlisted: 'Waitlisted',
                cancelled: 'Cancelled'
            },
            paymentStatus: {
                label: 'Payment Status',
                unpaid: 'Unpaid',
                paid: 'Paid',
                refunded: 'Refunded',
                partial: 'Partially Paid'
            },
            paymentMethod: {
                label: 'Payment Method',
                cash: 'Cash',
                creditCard: 'Credit Card',
                bankTransfer: 'Bank Transfer',
                wechat: 'WeChat Pay',
                alipay: 'Alipay',
                other: 'Other'
            },
            paymentDate: 'Payment Date',
            receipt: 'Payment Receipt',
            viewReceipt: 'View Receipt',
            noReceipt: 'No receipt uploaded',
            uploadReceipt: 'Upload Receipt',
            myCourses: 'My Courses',
            noCourses: 'You have no courses yet',
            coursesFetchError: 'Failed to fetch courses',
            today: 'Today',
            nextClass: 'Next Class',
            location: 'Location',
            students: 'students',
            markAttendance: 'Mark Attendance',
            courseStatus: {
                active: 'Active',
                pending: 'Upcoming',
                completed: 'Completed',
                cancelled: 'Cancelled'
            },
            activeCourses: 'Active Courses',
            noActiveCourses: 'You have no active courses',
            viewAllCourses: 'View All Courses',
            todaySchedule: 'Today\'s Schedule',
            coursesLabel: 'courses',
            courseLabel: 'course',
        },
        teacher: {
            allCourses: 'All Courses',
            filterByStatus: 'Filter by Status',
            allStatuses: 'All Statuses',
            noCoursesWithStatus: 'No {{status}} courses',
            viewStudents: 'View Students',
            showingCourses: 'Showing {{start}}-{{end}} of {{total}} courses',
            courseStudents: 'Course Students',
            totalStudents: 'Total Students',
            noStudentsInCourse: 'No students in this course',
        },
        header: {
            brand: {
                name: 'Great Lakes Academy',
                subtitle: 'Chinese Language School'
            },
            nav: {
                home: 'Home',
                programs: 'Programs',
                news: 'News'
            },
            userMenu: {
                profile: 'Profile',
                signOut: 'Sign Out'
            },
            mobileMenu: {
                close: 'Close menu'
            },
            language: {
                en: 'English',
                zh: '中文'
            },
            subnav: {
                title: 'Quick Navigation',
                home: 'Home',
                about: 'About Us',
                calendar: 'Calendars',
                projects: 'Programs',
                teachers: 'Our Team',
                contact: 'Contact Us',
                donate: 'Support Us'
            }
        },
        hero: {
            title: 'Learn Chinese, Explore Culture',
            subtitle: 'Start your Chinese learning journey at Great Lakes Academy',
            description: 'We offer professional Chinese language courses to help you master Chinese language skills and understand Chinese culture.',
            cta: {
                primary: 'Start Learning',
                secondary: 'Learn More'
            },
            stats: {
                students: {
                    value: '1000+',
                    label: 'Students'
                },
                courses: {
                    value: '50+',
                    label: 'Courses'
                },
                teachers: {
                    value: '20+',
                    label: 'Teachers'
                }
            },
            news: {
                title: 'Latest News',
                more: 'View More',
                empty: 'No news available'
            },
            notice: {
                title: 'Announcements',
                more: 'View More',
                empty: 'No announcements'
            },
            new: {
                badge: 'Inherit Inspire Innovate Influence',
                title: 'Great Lakes Academy',
                description: 'Start your Chinese learning journey at Great Lakes Academy',
                cta: {
                    primary: 'Start Learning',
                    secondary: 'Learn More'
                }
            }
        },
        features: {
            title: 'Our Features',
            subtitle: 'Why Choose Great Lakes Academy?',
            items: {
                curriculum: {
                    title: 'Professional Curriculum',
                    description: 'We offer systematic Chinese language courses, from beginner to advanced levels, meeting different learning needs.'
                },
                schedule: {
                    title: 'Flexible Schedule',
                    description: 'Providing diverse course arrangements that allow you to plan your study time flexibly.'
                },
                community: {
                    title: 'Active Learning Community',
                    description: 'Join our learning community and interact with learners from around the world.'
                }
            }
        },
        message: {
            title: 'Teaching Philosophy',
            subtitle: 'Our Promises',
            content: {
                title: 'Dedicated to Delivering Fun and Quality Education Through Diverse Courses',
                description: 'Great Lakes Academy is committed to providing a supportive and engaging learning environment where students can explore their passions, develop new skills, and achieve their full potential. While we emphasize fun, high-quality Chinese education, we also offer a diverse range of courses, including math, programming, and more. We aim to inspire curiosity, foster creativity, respect for diversity, and encourage a lifelong love of learning that extends beyond the classroom—preparing students for success in both academics and life.',
                highlight: 'Let every student find the joy of learning here and gain the power of knowledge.'
            }
        },
        programs: {
            section: {
                title: 'Featured Programs',
                subtitle: 'Our Programs',
                items: {
                    saturday: {
                        title: 'Saturday Program',
                        description: 'Chinese, math, and other enrichment classes are offered on Saturdays, providing students with an opportunity to learn Chinese and enhance their skills in various subjects during the weekends.',
                        level: 'All Levels',
                        duration: 'Weekly',
                        action: 'Learn More'
                    },
                    afternoon: {
                        title: 'After-school Program',
                        description: 'After-school Chinese classes are available every weekday, giving students daily opportunities to learn and practice the language.',
                        level: 'All Levels',
                        duration: 'Multiple Weekly',
                        action: 'Learn More'
                    },
                    summer: {
                        title: 'Summer Camp',
                        description: 'Immersive Chinese learning experience during summer, combining cultural activities and language learning.',
                        level: 'All Levels',
                        duration: '1-8 Weeks',
                        action: 'Learn More'
                    },
                    online: {
                        title: 'Online Program',
                        description: 'Flexible online learning options, learn Chinese anywhere.',
                        level: 'All Levels',
                        duration: 'Self-paced',
                        action: 'Learn More'
                    }
                }
            }
        },
        testimonials: {
            title: 'Testimonials',
            subtitle: 'What They Say',
            items: [
                {
                    content: 'Learning Chinese at Great Lakes Academy has been a wonderful experience. The teachers are professional, and the curriculum is well-structured, helping me make significant progress in a short time.',
                    author: {
                        name: 'Sarah Chen',
                        role: 'Beginner Student',
                        company: 'From USA'
                    }
                },
                {
                    content: 'As a complete beginner, I appreciate the systematic learning approach at Great Lakes Academy. The courses are engaging and make learning Chinese enjoyable.',
                    author: {
                        name: 'Michael Wang',
                        role: 'Intermediate Student',
                        company: 'From Canada'
                    }
                },
                {
                    content: 'The business Chinese section in the advanced course has been incredibly helpful for my work. Now I can confidently conduct business communications in Chinese.',
                    author: {
                        name: 'Emma Liu',
                        role: 'Advanced Student',
                        company: 'From UK'
                    }
                }
            ]
        },
        footer: {
            about: {
                title: 'About Us',
                description: 'Great Lakes Academy is committed to providing high-quality Chinese education to students. We also offer math, programming, and more.'
            },
            links: {
                title: 'Quick Links',
                items: {
                    home: 'Home',
                    about: 'About Us',
                    programs: 'Programs',
                    contact: 'Contact Us',
                    donate: 'Support Us'
                }
            },
            contact: {
                title: 'Contact Information',
                address: '3300 Plymouth Blvd # 46253 Plymouth, MN 55447',
                phone: '(952) 546-1000',
                email: 'info@greatlakeacademy.ca'
            },
            social: {
                title: 'Follow Us',
                items: {
                    facebook: 'Facebook',
                    twitter: 'Twitter',
                    instagram: 'Instagram',
                    linkedin: 'LinkedIn'
                }
            },
            copyright: '© 2025 Great Lakes Academy. All rights reserved.'
        },
        programsList: {
            hero: {
                title: 'Programs',
                description: 'Explore our diverse program offerings',
                browseButton: 'Browse Programs'
            },
            categories: {
                all: 'All Programs',
                saturday: 'Saturday Programs',
                afterSchool: 'After-school',
                summerCamp: 'Summer Camp',
                satAct: 'Online Programs',
                volunteer: 'Volunteer Programs'
            },
            status: {
                loading: 'Loading...',
                empty: {
                    title: 'Something amazing is brewing!',
                    subtitle: 'Come back soon to see what is new.'
                },
                showActive: 'Show Active Programs',
                active: 'Active',
                inactive: 'Inactive'
            },
            loadMore: {
                text: 'Load More',
                loading: 'Loading...',
                button: 'Load More'
            }
        },
        programCard: {
            status: {
                active: 'Active',
                inactive: 'Ended',
                upcoming: 'Upcoming'
            }
        },
        program: {
            backToList: 'Back to List',
            publishDate: 'Publish Date',
            category: 'Category',
            status: 'Status',
            notFound: 'Program Not Found',
            notFoundDesc: 'Sorry, the program you are looking for does not exist or has been removed.',
            loginRequired: 'Please login to enroll in this course',
            noCourses: 'No courses available',
            availableCourses: 'Available Courses',
            availableCamps: 'Available Camps',
            categories: {
                saturday: 'Weekend Program',
                afterSchool: 'After-School',
                summerCamp: 'Summer Camp',
                satAct: 'Online Program',
                volunteer: 'Volunteer Program'
            },
            statuses: {
                active: 'Active',
                inactive: 'Completed',
                upcoming: 'Upcoming',
                draft: 'Draft'
            }
        },
        course: {
            duration: 'Duration',
            minutes: 'minutes',
            schedule: 'Schedule',
            moreSchedules: '{count} more sessions',
            enroll: 'Enroll Now',
            canNotEnroll: 'Enrollment period has expired',
            loading: 'Loading...',
            notFound: 'Course not found',
            fetchError: 'Failed to fetch course information',
            allowCustomSchedule: 'Allow Custom Schedule',
            fixedSchedule: 'Fixed Schedule',
            scheduleSelectionDisabled: 'This course does not allow custom schedule selection. Classes will follow the preset schedule.',
            scheduleSelectionEnabled: 'You can select class dates according to your own schedule',
            enrollmentOpen: 'Enrollment Open',
            enrollmentClosed: 'Enrollment Closed',
        },
        registration: {
            required: 'This program requires at least one course',
            title: 'Registration',
            totalPrice: 'Total Price (includes management fee)',
            earlyBirdPrice: 'Early Bird Price',
            afterDiscountDate: 'Paid After {{date}}',
            beforeDiscountDate: 'Paid On or Before {{date}}',
            discountDeadline: 'Discount Deadline',
            program: 'Program',
            selectCourses: 'Select Courses',
            noCoursesAvailable: 'No courses available',
            noCourseSelected: 'Please select at least one course',
            requiredCoursesNotSelected: 'Please select all required course groups',
            studentInfo: 'Student Information',
            firstName: 'First Name',
            lastName: 'Last Name',
            chineseName: 'Chinese Name',
            gender: 'Gender',
            selectGender: 'Select Gender',
            male: 'Male',
            female: 'Female',
            other: 'Other',
            dateOfBirth: 'Date of Birth',
            grade: 'Grade',
            selectGrade: 'Select Grade',
            fullTimeSchoolName: 'Full-time School Name (required for after-school program)',
            fullTimeSchoolNamePlaceholder: 'Please enter your full-time school name',
            grades: {
                kindergarten: 'Kindergarten',
                grade1: 'Grade 1',
                grade2: 'Grade 2',
                grade3: 'Grade 3',
                grade4: 'Grade 4',
                grade5: 'Grade 5',
                grade6: 'Grade 6',
                grade7: 'Grade 7',
                grade8: 'Grade 8',
                grade9: 'Grade 9',
                grade10: 'Grade 10',
                grade11: 'Grade 11',
                grade12: 'Grade 12',
                other: 'Other'
            },
            allergies: 'Allergies',
            allergiesPlaceholder: 'Please list any allergies (food, medication, etc.) if applicable',
            parentInfo: 'Parent/Guardian Information',
            parentFirstName: 'Parent First Name',
            parentLastName: 'Parent Last Name',
            phone: 'Phone Number',
            email: 'Email Address',
            address: 'Address',
            addressPlaceholder: 'Street number and name',
            aptNumber: 'Apt/Unit Number',
            aptNumberPlaceholder: 'Apartment or unit number (optional)',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            emergencyContact: 'Emergency Contact',
            emergencyFirstName: 'First Name',
            emergencyLastName: 'Last Name',
            emergencyPhone: 'Phone',
            emergencyEmail: 'Email',
            emergencyAddress: 'Address',
            emergencyAddressPlaceholder: 'street number and name',
            emergencyAptNumber: 'Apt/Unit Number',
            emergencyAptNumberPlaceholder: 'apartment or unit number (optional)',
            emergencyCity: 'City',
            emergencyState: 'State',
            emergencyZipCode: 'Zip Code',
            additionalInfo: 'Additional Information',
            parentMessage: 'Parent Message',
            parentMessagePlaceholder: 'Any additional information you would like us to know',
            submit: 'Submit Registration',
            submitting: 'Submitting...',
            cancel: 'Cancel',

            // Validation error messages
            firstNameRequired: 'First name is required',
            lastNameRequired: 'Last name is required',
            genderRequired: 'Gender is required',
            dateOfBirthRequired: 'Date of birth is required',
            gradeRequired: 'Grade is required',
            parentFirstNameRequired: 'Parent first name is required',
            parentLastNameRequired: 'Parent last name is required',
            phoneRequired: 'Phone number is required',
            invalidPhone: 'Please enter a valid phone number',
            emailRequired: 'Email address is required',
            invalidEmail: 'Please enter a valid email address',
            addressRequired: 'Address is required',
            cityRequired: 'City is required',
            stateRequired: 'State is required',
            zipCodeRequired: 'Zip code is required',
            emergencyFirstNameRequired: 'Emergency contact first name is required',
            emergencyLastNameRequired: 'Emergency contact last name is required',
            emergencyPhoneRequired: 'Emergency contact phone is required',
            invalidEmergencyPhone: 'Please enter a valid emergency contact phone number',
            emergencyEmailRequired: 'Emergency contact email is required',
            invalidEmergencyEmail: 'Please enter a valid emergency contact email',
            emergencyAddressRequired: 'Emergency contact address is required',
            emergencyCityRequired: 'Emergency contact city is required',
            emergencyStateRequired: 'Emergency contact state is required',
            emergencyZipCodeRequired: 'Emergency contact zip code is required',

            // Error messages
            programNotFound: 'Program not found',
            courseNotFound: 'Course not found',
            noProgramSelected: 'No program selected',
            fetchError: 'Failed to fetch data. Please try again later',
            submitError: 'Failed to submit registration. Please try again later',

            // Agreement confirmation
            agreementTitle: 'Agreement Confirmation',
            agreementDescription: 'Please read the following agreement carefully. Click "Agree & Continue" to indicate that you have read and agree to the terms.',
            agreementProgress: 'Agreement {current} of {total}',
            agreeAndNext: 'Agree & Continue',
            agreeAll: 'Agree & Continue',
            continue: 'Continue',
            previous: 'Previous',
            noAgreements: 'No agreements to confirm',
            agreementFetchError: 'Failed to fetch agreements. Please try again later',
            skipAgreements: 'Skip Agreements',
            agreements: {
                terms: {
                    title: 'Terms and Conditions',
                    version: '1.0',
                    instruction: 'Please read and agree to the following terms and conditions before proceeding with registration.'
                },
                privacy: {
                    title: 'Privacy Policy',
                    version: '1.0',
                    instruction: 'Please read and agree to our privacy policy before proceeding with registration.'
                },
                liability: {
                    title: 'Liability Waiver',
                    version: '1.0',
                    instruction: 'Please read and agree to the liability waiver before proceeding with registration.'
                },
                photo: {
                    title: 'Photo/Video Release',
                    version: '1.0',
                    instruction: 'Please read and agree to the photo and video release agreement before proceeding with registration.'
                },
                medical: {
                    title: 'Medical Authorization',
                    version: '1.0',
                    instruction: 'Please read and agree to the medical authorization form before proceeding with registration.'
                }
            },

            // Success messages
            submitSuccess: 'Registration submitted successfully!',
            redirecting: 'Redirecting to success page...',
            backToPrograms: 'Back to Programs',
            selectDates: 'Select Course Dates',
            selectAll: 'Select All',
            deselectAll: 'Deselect All',
            selectedDays: 'Selected Days',
            unitPrice: 'Price Per Day',
            previousInfoUsed: 'Your previous registration information has been used',
            checkAndUpdate: 'Please check and update the information as needed',
            fetchDataError: 'Failed to fetch data, please try again later',
            unknownProgram: 'Unknown Program',
            unknownCourse: 'Unknown Course',

            // Course selection
            multipleCourseSelection: 'Please select the courses you would like to register for.',
            singleCourseAvailable: 'You can choose one of the courses in this group.',
            selectedCourses: 'Selected courses',
        },
        registrationSuccess: {
            title: 'Registration Successful!',
            subtitle: 'Your course registration has been submitted',
            registrationDetails: 'Registration Details',
            registrationId: 'Registration ID',
            programTitle: 'Program Title',
            studentName: 'Student Name',
            program: 'Program',
            course: 'Course',
            courses: 'Courses',
            noCourseSelected: 'No courses selected',
            status: 'Status',
            pending: 'Pending Review',
            priceDetails: 'Price Details',
            discountDeadline: 'Discount Deadline',
            totalPrice: 'Total Price (includes management fee)',
            earlyBirdPrice: 'Early Bird Price (before discount deadline)',
            regularPrice: 'Regular Price',
            ifPaidBefore: 'If paid on or before {{date}}',
            ifPaidAfter: 'If paid after {{date}}',
            includingManagementFee: 'Including Management Fee',
            paymentOptions: 'Payment Options',
            option1: 'Option 1: Zelle Transfer',
            option2: 'Option 2: Mail a Check',
            zelleInfo: 'Please send tuition via Zelle to {email}',
            zelleNote1: 'Include your Registration ID ({registrationId}) and student name in the memo field',
            zelleNote2: 'Zelle payments are usually processed instantly',
            zelleNote3: 'Contact us if you have any questions about payment',
            checkInfo: 'Please make the check payable to Great Lakes Academy and mail it to the following address:',
            checkNote: 'Be sure to write your Registration ID ({registrationId}) and student name on the check memo',
            nextSteps: 'Next Steps',
            step1: 'We will review your registration within five business days and email you if there are any questions.',
            step2: 'Please make the payment promptly to avoid cancellation of your registration.',
            step3: 'Once payment is complete, you will receive a course confirmation email.',
            viewProfile: 'View Profile',
            browsePrograms: 'Browse Programs',
            invalidAccess: 'Invalid Access',
            invalidAccessDesc: 'It seems you accessed this page directly. Please go through the normal registration process.'
        },
        emailVerification: {
            title: 'Email Verification',
            subtitle: 'Please Verify Your Email',
            description: 'We have sent a verification email to your inbox. Please check your email and click the verification link to complete the verification.',
            checkInbox: 'Check Inbox',
            resendEmail: 'Resend Verification Email',
            resendWait: 'seconds remaining',
            backToProfile: 'Back to Profile',
            resendSuccess: 'Verification email has been resent',
            resendError: 'Failed to send, please try again later',
            cooldown: 'Resend in {seconds}s',
            verifySuccess: 'Email verified successfully',
            verifyError: 'Verification failed, please try again',
            successMessage: 'Email verified successfully',
            errorMessage: 'Verification failed, please try again',
            verifyComplete: 'I have verified my email',
            verifyChecking: 'Checking verification status...',
            verifyNotComplete: 'Email not verified yet. Please check your inbox or resend the verification email',
        },
        gallery: {
            title: 'Fun Moments',
            subtitle: 'Campus Life',
            mainTitle: 'WE INSPIRE EACH',
            controls: {
                scrollLeft: 'Scroll left',
                scrollRight: 'Scroll right',
                pause: 'Pause auto-scroll',
                play: 'Start auto-scroll'
            },
            lightbox: {
                previous: 'Previous image',
                next: 'Next image',
                close: 'Close preview'
            },
            images: {
                drawing: {
                    title: 'Drawing',
                    description: 'Students expressing creativity through visual arts and developing fine motor skills'
                },
                music: {
                    title: 'Music',
                    description: 'Developing musical talents and appreciation for harmony through diverse instruments and vocal training'
                },
                science: {
                    title: 'Science',
                    description: 'Exploring the wonders of the natural world through hands-on experiments and scientific inquiry'
                },
                socialStudies: {
                    title: 'Social Studies',
                    description: 'Understanding societies, histories, and global connections through interactive learning'
                },
                teamwork: {
                    title: 'Teamwork',
                    description: 'Building collaboration skills and learning to work effectively with peers on group projects'
                },
                art: {
                    title: 'Art',
                    description: 'Cultivating aesthetic sensibility and creative expression through various artistic mediums'
                },
                literature: {
                    title: 'Literature',
                    description: 'Exploring the world of stories, poems and literary masterpieces to foster reading and comprehension'
                },
                sports: {
                    title: 'Physical Education',
                    description: 'Promoting physical fitness, teamwork, and healthy lifestyle through diverse sports activities'
                },
                technology: {
                    title: 'Technology',
                    description: 'Developing digital literacy and computational thinking skills for the modern world'
                },
                language: {
                    title: 'Languages',
                    description: 'Mastering multiple languages to become effective global communicators and cultural ambassadors'
                },
                mathematics: {
                    title: 'Mathematics',
                    description: 'Building strong numerical foundations and problem-solving skills through engaging activities'
                },
                default: {
                    title: 'Great Moments',
                    description: 'Memorable moments at Great Lakes Academy'
                }
            },
            cards: [
                {
                    title: 'Educational Philosophy',
                    description: 'We are committed to providing quality educational resources and learning experiences for every student.'
                },
                {
                    title: 'Professional Courses',
                    description: 'Through professional course design and teaching services, we help students achieve personal growth and career development.'
                },
                {
                    title: 'Teaching Staff',
                    description: 'We have a team of experienced and qualified teachers dedicated to providing high-quality teaching services.'
                },
                {
                    title: 'Teaching Achievements',
                    description: 'Our teaching achievements have been highly recognized and praised by students and parents.'
                }
            ]
        },
        student: {
            male: 'Male',
            female: 'Female',
            other: 'Other',
            yearsOld: 'years old',
            parentInfo: 'Parent Information',
            parentName: 'Parent Name',
            parentFirstName: 'Parent First Name',
            parentLastName: 'Parent Last Name',
            parentPhone: 'Parent Phone',
            fetchError: 'Failed to fetch student information',
            exportCSV: 'Export Student List',
        },
        reimbursements: {
            title: 'Reimbursements',
            create: 'Create Reimbursement',
            edit: 'Edit Reimbursement',
            amount: 'Amount',
            type: 'Type',
            description: 'Description',
            receipts: 'Receipts',
            receiptsHelp: 'Please upload photos/scans of invoices or receipts (images and PDF supported)',
            existingReceipts: 'Existing Receipts',
            newReceipts: 'New Receipts',
            additionalDocuments: 'Additional Documents',
            additionalDocumentsHelp: 'You can upload other supporting documents (images, PDF, Word and Excel files supported)',
            createdAt: 'Created At',
            updatedAt: 'Updated At',
            reviewedAt: 'Reviewed At',
            paymentDate: 'Payment Date',
            addNew: 'Add New',
            createFirst: 'Create First Reimbursement',
            noRecords: 'No reimbursement records',
            fetchError: 'Failed to fetch reimbursements. Please try again later.',
            submitError: 'Failed to submit reimbursement. Please try again later.',
            notFound: 'Reimbursement not found',
            deleteConfirm: 'Are you sure you want to delete this reimbursement?',
            deleteSuccess: 'Deleted successfully',
            deleteError: 'Failed to delete. Please try again later.',
            viewAll: 'View All',
            allReimbursements: 'All Reimbursements',
            filterByStatus: 'Filter by Status',
            allStatuses: 'All Statuses',
            showingReimbursements: 'Showing {{start}} to {{end}} of {{total}} reimbursements',
            noReimbursementsWithStatus: 'No reimbursements with {{status}} status',
            status: {
                pending: 'Pending',
                approved: 'Approved',
                rejected: 'Rejected',
                paid: 'Paid'
            },
            types: {
                teaching_materials: 'Teaching Materials',
                travel: 'Travel',
                office_supplies: 'Office Supplies',
                equipment: 'Equipment',
                other: 'Other'
            },
            noReceipts: 'No receipts',
            reviewComment: 'Review Comment',
            uploadReceipts: 'Upload receipts',
            uploadDocuments: 'Upload documents',
            dragAndDrop: 'or drag and drop',
            preview: 'Preview',
            new: 'New',
            existingDocuments: 'Existing Documents',
            newDocuments: 'New Documents',
        },
        attendance: {
            title: 'Attendance Management',
            records: 'Attendance Records',
            viewDetails: 'View Details',
            startAttendance: 'Start Attendance',
            studentName: 'Student Name',
            studentList: 'Student List',
            signInTime: 'Sign-in Time',
            signOutTime: 'Sign-out Time',
            signInBy: 'Signed in by',
            signOutBy: 'Signed out by',
            status: 'Status',
            present: 'Present',
            absent: 'Absent',
            late: 'Late',
            early: 'Left Early',
            actions: 'Actions',
            attendees: 'Attendees',
            noRecords: 'No attendance records found',
            deleteConfirmation: 'Are you sure you want to delete this attendance record?',
            markAsPresent: 'Mark as Present',
            markAsAbsent: 'Mark as Absent',
            markAsLate: 'Mark as Late',
            markAsEarlyLeave: 'Mark as Left Early',
            signIn: 'Sign In',
            signOut: 'Sign Out',
            signedIn: 'Signed In',
            signedOut: 'Signed Out',
            clickToSignIn: 'Click to sign in',
            clickToSignOut: 'Click to sign out',
            notStarted: 'Not Started',
            exporting: 'Exporting...',
            cannotCreateInactive: 'Cannot create attendance for inactive projects',
            createAttendance: 'Create Attendance Record',
            createPrompt: 'Create Custom Attendance Record',
            createdBy: 'Created by',
            selectDate: 'Select Date',
            exportCsv: 'Export to CSV',
            exportRangeCsv: 'Export by Date Range',
            exportDateRange: 'Export Attendance Date Range',
            startDate: 'Start Date',
            endDate: 'End Date',
            noRecordsInRange: 'No attendance records found in the selected date range',
            invalidDateRange: 'Start date cannot be later than end date',
            goBack: 'Please go back to the attendance list',
            signInDialogTitle: 'Sign In',
            signOutDialogTitle: 'Sign Out',
            batchSignIn: 'Batch Sign In',
            batchSignInDialogTitle: 'Batch Sign In Students',
            selectAll: 'Select All',
            deselectAll: 'Deselect All',
            selectedCount: 'Selected {count} of {total}',
            allStudentsSignedIn: 'All students have already signed in',
            batchSignInConfirm: 'Sign In {count} Students',
            nameLabel: 'Your Name',
            namePlaceholder: 'Enter your name',
            detail: {
                status: {
                    present: 'Present',
                    absent: 'Absent',
                    late: 'Late',
                    early: 'Left Early'
                }
            },
            confirmDelete: 'Confirm Delete',
            deleteWarning: 'This action will permanently delete this attendance record. Continue?',
            delete: 'Delete',
            
            // Teacher attendance related translations
            teacherAttendanceTitle: 'Teacher Attendance Status',
            teacherRecords: 'Teacher Attendance Records',
            noActivePrograms: 'No active programs',
            noTeacherRecords: 'No teacher attendance records',
            noTeachers: 'No teachers found',
            createTeacherAttendance: 'Create Attendance Record',
            createError: 'Failed to create',
            notFound: 'Attendance record not found',
            fetchError: 'Failed to fetch data',
            deleteError: 'Failed to delete',
            saveError: 'Failed to save',
            saveSuccess: 'Successfully saved',
            notesPlaceholder: 'Enter notes',
            notes: 'Notes'
        },
        donate: {
            title: 'Support Us',
            subtitle: 'Your contribution makes a difference in the lives of our students',
            introduction: {
                title: 'Why Your Support Matters',
                description: 'Your generous donations help us provide quality education, state-of-the-art facilities, and enriching programs for our students. Together, we can create an environment where every student can thrive and reach their full potential.'
            },
            methods: {
                title: 'Ways to Donate',
                online: {
                    title: 'Online Donation',
                    description: 'Make a secure online donation using your credit card or PayPal account.'
                },
                check: {
                    title: 'Donate by Check',
                    description: 'Please make checks payable to "Great Lakes Academy" and mail to:',
                    address: '3300 Plymouth Blvd # 46253 Plymouth, MN 55447'
                },
                bank: {
                    title: 'Bank Transfer',
                    description: 'For wire transfers, please use the following bank information:',
                    details: 'Bank: First National Bank\nAccount Name: Great Lake International School\nAccount Number: 12345678\nRouting Number: 87654321\nSWIFT Code: FNBGLIS'
                },
                other: {
                    title: 'Other Ways to Give',
                    description: 'We also accept donations of securities, matching gifts, and planned giving. Please contact our donation office for more information.',
                    contact: 'Email: donations@greatlake.edu\nPhone: (123) 456-7890'
                }
            },
            projects: {
                title: 'Current Initiatives',
                description: 'Your donation can support these important projects:',
                items: [
                    {
                        title: 'Scholarship Fund',
                        description: 'Help provide educational opportunities for talented students regardless of financial circumstances.',
                        goal: 100000,
                        raised: 65000
                    },
                    {
                        title: 'Library Expansion',
                        description: 'Support our efforts to expand our library collection and create a modern learning space.',
                        goal: 50000,
                        raised: 30000
                    },
                    {
                        title: 'STEM Innovation Lab',
                        description: 'Contribute to building a state-of-the-art laboratory for science, technology, engineering, and mathematics.',
                        goal: 75000,
                        raised: 25000
                    },
                    {
                        title: 'Arts Program',
                        description: 'Help enhance our visual and performing arts programs with new equipment and opportunities.',
                        goal: 40000,
                        raised: 15000
                    }
                ]
            },
            form: {
                title: 'Make a Donation',
                fullName: 'Full Name',
                email: 'Email Address',
                amount: 'Donation Amount',
                custom: 'Custom Amount',
                project: 'Select Project',
                recurring: {
                    label: 'Make this a recurring donation',
                    options: {
                        once: 'One-time donation',
                        monthly: 'Monthly donation',
                        quarterly: 'Quarterly donation',
                        annually: 'Annual donation'
                    }
                },
                anonymous: 'Make this donation anonymous',
                comment: 'Comments (Optional)',
                submit: 'Donate Now',
                success: 'Thank you for your generous donation!',
                errorMessage: 'There was an error processing your donation. Please try again.'
            },
            donors: {
                title: 'Our Generous Donors',
                subtitle: 'We are grateful for the support of the following individuals and organizations',
                anonymous: 'Anonymous Donor',
                noData: 'No donation data available yet',
                categories: {
                    platinum: 'Platinum Donors ($10,000+)',
                    gold: 'Gold Donors ($5,000 - $9,999)',
                    silver: 'Silver Donors ($1,000 - $4,999)',
                    bronze: 'Bronze Donors (Up to $999)'
                },
                thankYou: 'Thank you to all our donors for your generous support!',
                table: {
                    name: 'Donor',
                    amount: 'Amount',
                    year: 'Year',
                    project: 'Project',
                    notes: 'Notes'
                },
                note: '* Only displaying donors who have given permission to be listed publicly',
                noNotes: 'No notes',
                description: 'We are deeply grateful to the following donors for their generous contributions. Their support enables us to continually enhance the quality of education and create a better learning environment for our students.'
            },
            faq: {
                title: 'Frequently Asked Questions',
                questions: [
                    {
                        question: 'Is my donation tax-deductible?',
                        answer: 'Yes, all donations to Great Lake International School are tax-deductible to the extent allowed by law. You will receive a receipt for your donation that can be used for tax purposes.'
                    },
                    {
                        question: 'How will my donation be used?',
                        answer: 'Your donation will be used according to your designation. If you select a specific project, 100% of your donation will go toward that initiative. Undesignated gifts will be applied where the need is greatest.'
                    },
                    {
                        question: 'Can I make a recurring donation?',
                        answer: 'Yes, you can set up a recurring donation on a monthly, quarterly, or annual basis. This is a convenient way to provide ongoing support to our school.'
                    },
                    {
                        question: 'How do I make changes to my recurring donation?',
                        answer: 'You can make changes to your recurring donation by contacting our donation office at donations@greatlake.edu or calling (123) 456-7890.'
                    },
                    {
                        question: 'Can I donate in memory or honor of someone?',
                        answer: 'Yes, you can make a tribute or memorial gift. Just include the name of the person you are honoring in the comments section of the donation form.'
                    }
                ]
            },
            events: {
                title: 'Fundraising Events',
                description: 'We welcome community partners to participate in our fundraising efforts. Events include:',
                noData: 'No fundraising events available at the moment.',
                type1: 'Benefit Dinners or Galas',
                type2: 'Charity Auctions (Live or Silent)',
                type3: 'Walk-a-thons / Fun Runs',
                type4: 'Concerts, Performances, or Cultural Festivals',
                type5: 'Online Fundraising Events / Livestreams',
                type6: 'Holiday Markets / Craft Fairs'
            }
        },
        contact: {
            title: 'Contact Us',
            subtitle: 'We\'d love to hear from you',
            form: {
                title: 'Send us a message',
                name: 'Your Name',
                email: 'Email Address',
                phone: 'Phone Number',
                subject: 'Subject',
                message: 'Your Message',
                submit: 'Send Message',
                success: 'Your message has been sent successfully!',
                error: 'There was an error sending your message. Please try again.'
            },
            info: {
                title: 'Contact Information',
                address: {
                    title: 'Address',
                    line1: '3300 Plymouth Blvd',
                    line2: '# 46253',
                    line3: 'Plymouth, MN 55447, United States'
                },
                phone: {
                    title: 'Phone',
                    main: 'Main Office: (123) 456-7890',
                    admissions: 'Admissions: (123) 456-7891',
                    support: 'Technical Support: (123) 456-7892'
                },
                email: {
                    title: 'Email',
                    general: 'info@greatlake.edu',
                    admissions: 'admissions@greatlake.edu',
                    support: 'support@greatlake.edu'
                },
                hours: {
                    title: 'Office Hours',
                    weekdays: 'Monday - Friday: 8:00 AM - 5:00 PM',
                    weekend: 'Saturday: 9:00 AM - 12:00 PM',
                    closed: 'Sunday: Closed'
                }
            },
            directoryHeading: 'Staff Directory',
            formValidation: {
                nameRequired: 'Please enter your name',
                emailRequired: 'Please enter your email address',
                emailInvalid: 'Please enter a valid email address',
                phoneRequired: 'Please enter your phone number',
                phoneInvalid: 'Please enter a valid phone number',
                subjectRequired: 'Please enter a subject',
                messageRequired: 'Please enter your message'
            }
        },
        teachers: {
            title: 'Our Team',
            subtitle: 'Great Lakes Academy has a professional, dedicated, and passionate team',
            introduction: {
                title: 'Executive and Teaching Team',
                paragraph1: 'Great Lakes Academy has an experienced and passionate management and teaching team. Our core members are senior education experts who have been deeply involved in education for many years. We not only have a solid professional background but also are familiar with the learning characteristics of K-12 students. The management team emphasizes a scientific and humanistic approach to running the school, committed to providing high-quality educational services to teachers, students, and parents, and creating a positive learning community.',
                paragraph2: 'Our teaching team is our core strength, consisting of both veteran Chinese education backbones who have taught in the U.S. for decades and young teachers with the latest perspectives. All teachers have received higher education and regularly participate in teaching training and academic exchanges to ensure that teaching concepts and methods keep pace with the times. With patience, responsibility, and an innovative spirit, we help students make progress in language and extended subject learning.',
                paragraph3: "We believe that education is not only the transmission of knowledge but also the enlightenment of the mind. The teachers at Great Lakes Academy not only impart knowledge but also focus on the individual development of each student. Through rich cultural activities and interactive classrooms, we stimulate students' interest in learning. With a professional, warm, and continuously improving attitude, we accompany students in their growth and help them move forward confidently in a multicultural environment."
            },
            searchPlaceholder: 'Search teacher name, title or bio',
            departmentFilter: 'Department Filter',
            noResults: 'No matching teachers found, please try other filtering criteria',
            education: 'Education',
            specialties: 'Teaching Courses',
            contact: 'Contact',
            joinUs: {
                title: 'Join Our Team',
                description: 'Great Lakes Academy always welcomes excellent educators to join our team. If you love education, have an innovative spirit, and wish to work in a vibrant environment, please contact us.',
                contactUs: 'Contact Us'
            },
            viewDetails: 'Learn More'
        },
        about: {
            title: 'About Us',
            subtitle: 'Cultivating future leaders, preserving cultural heritage',
            introduction: {
                title: 'Our Academy',
                paragraph1: 'Great Lakes Academy (GLA) is a nonprofit educational and cultural organization, established in 2025 in Minnesota. Our mission is to provide high-quality educational programs and cultural enrichment opportunities that promote academic excellence, leadership development, global citizenship, and community engagement.',
                paragraph2: 'At GLA, we offer sustained and systematic educational programs in Chinese language, culture, math and other academic subjects to help prepare students for future success. Our programs foster cultural exchange and encourage active participation in the community, strengthening social responsibility and appreciation for diversity.',
                paragraph3: 'Over the years, GLA has educated thousands of outstanding graduates who have achieved excellence in their respective fields and become pillars of society.',
                imageAlt: 'Great Lakes Academy Campus'
            },
            history: {
                title: 'Our History',
                2010: 'Great Lakes Academy was officially established, with the first batch of 50 students enrolled.',
                2013: 'Campus expansion, adding an arts center and science laboratory.',
                2015: 'The first graduating class was admitted to renowned universities both domestically and internationally.',
                2018: 'Received the "National Outstanding Educational Institution" award.',
                2020: 'Celebrated the 10th anniversary with a grand ceremony and launched the "Next Decade" development plan.',
                2023: 'Established the International Exchange Center and formed partnerships with several internationally renowned schools.'
            },
            campus: {
                title: 'Our Campus',
                image1Alt: 'Campus Scenery',
                image1Title: 'Beautiful Environment',
                image1Text: 'Our campus is situated by the lake, surrounded by beautiful scenery and lush greenery, providing students with a peaceful and comfortable learning environment.',
                image2Alt: 'Modern Classroom',
                image2Title: 'Modern Facilities',
                image2Text: 'Equipped with advanced teaching facilities and technology, including smart classrooms, multimedia laboratories, and libraries.',
                image3Alt: 'Activity Center',
                image3Title: 'Activity Spaces',
                image3Text: 'Features multi-functional activity centers, sports facilities, and arts performance centers to meet students\' diverse interests and needs.'
            }
        },
        calendar: {
            title: 'Calendars',
            subtitle: 'Stay informed about the school schedule and never miss important events',
            error: {
                fetch: 'Failed to fetch calendar data'
            },
            noCalendars: 'No calendars available',
            uploadDate: 'Upload Date',
            download: 'Download Calendar',
            status: {
                active: 'Published',
                draft: 'Draft',
                archived: 'Archived'
            },
            filter: {
                all: 'All',
                active: 'Published',
                draft: 'Draft',
                archived: 'Archived'
            },
            preview: {
                title: 'Preview Calendar',
                close: 'Close Preview'
            }
        },
        news: {
            title: 'News',
            subtitle: 'Guide news in the right direction and fully understand our connection with the world',
            categories: {
                all: 'All',
                news: 'News',
                notice: 'Announcements'
            },
            pagination: {
                previous: 'Previous',
                next: 'Next'
            },
            empty: 'No articles available',
            unpublished: 'Not published',
            backToList: 'Back to List'
        },
        article: {
            notFound: 'Article not found',
            backToList: 'Back to List'
        }
    }
}; 
